import { ButtonProps } from '@material-ui/core';
import { CheckBox } from '@material-ui/icons';
import React, { Suspense } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import LayoutForm from '../../../components/Layout/LayoutForm';
import ActionsMenu from '../../../components/Layout/Menus/ActionsMenu/ActionsMenu';
import useButtons from '../../../helpers/customHooks/useButtons';
import { tKey } from '../../../helpers/translate';
import { InvoiceDetail, InvoiceListItem } from '../../../redux/accounting/definitions';
import { buttonsInvoice } from '../../Entities/Invoices/invoiceButtons';
import AccountingSubmenu from '../AccountingSubmenu';
import InvoiceForm from './InvoiceForm';

const TrackingModal = React.lazy(() => import('../../../components/Modal/TrackingModal/TrackingModal'));

interface InvoiceConfigProps extends RouteComponentProps<{ id: string }> {
  invoice: InvoiceListItem;
  invoiceDetails: InvoiceDetail;
}

const InvoiceConfig: React.FC<InvoiceConfigProps> = ({ match }) => {
  const { stateButtons, setButtonProperty } = useButtons(buttonsInvoice());
  const [trackingModal, setTrackingModal] = React.useState(false);
  const invoice_id = parseInt(match.params.id);

  const moreInfoButtons: ButtonProps[] = [
    {
      children: tKey('invoice.actions.tracking').toLocaleUpperCase(),
      startIcon: <CheckBox />,
      fullWidth: true,
      color: 'primary',
      onClick: () => {
        setTrackingModal(true);
      },
    },
  ];

  const actionButtons: ButtonProps[] = [
    stateButtons.buttonOnSave,
    stateButtons.buttonOnAccept,
    stateButtons.buttonOnConfirm,
    stateButtons.buttonToAccounting,
    stateButtons.buttonAuthorize,
    stateButtons.buttonOnReject,
    stateButtons.buttonModify,
  ];

  return (
    <LayoutForm
      rightSubmenu={<ActionsMenu actionsButtons={actionButtons} moreInfoButtons={moreInfoButtons} />}
      leftSubmenu={<AccountingSubmenu selected="invoices" />}
    >
      <InvoiceForm invoice_id={invoice_id} setButtonProperty={setButtonProperty} />
      <Suspense fallback={<></>}>
        <TrackingModal
          view={trackingModal}
          resource_id={invoice_id}
          resource_type={'Invoice'}
          title={`${tKey('Facturas de servicios')} - Id: ${invoice_id}`}
          handleClose={() => setTrackingModal(false)}
        />
      </Suspense>
    </LayoutForm>
  );
};

export default InvoiceConfig;
